function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "param(fill) #CC0000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 6l10-4.245C19.714.751 18.72 0 17.535 0H2.465C1.28 0 .285.75 0 1.755L10 6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 6l10-4.286C19.714.704 18.72 0 17.535 0H2.465C1.28 0 .285.706 0 1.714L10 6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 8.583L0 4v8.3C0 13.785 1.14 15 2.532 15h14.936C18.861 15 20 13.785 20 12.3V4L10 8.583z"
}));

function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 15",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgSend;